module.exports = __webpack_public_path__ + "teqbahn-assets/media/22.b4355a51.png";